import { Context, createContext } from 'react';
import { IDBPObjectStore } from 'idb';

export interface IDbContext {
    getTasks?: () => IDBPObjectStore;
}

const DbContext: Context<IDbContext> = createContext<IDbContext>({
    getTasks: undefined
});

export default DbContext;
